import React from 'react';
import { createPortal } from 'react-dom';

// NOTE: portal to <body> so the overlay is never trapped by a transformed
// ancestor (e.g. .animate-fade-up sets transform, which turns any
// position:fixed descendant into position:absolute relative to itself).
const HexLoader = ({ label = 'Processing', sub = 'Confirming on-chain transaction', showBrand = true }) => {
  const overlay = (
    <div className="hex-loader-overlay">
      <div className="hex-loader-stage">
        <div className="hex-loader-ring r2" />
        <div className="hex-loader-ring r1" />
        <div className="hex-loader-ring" />
        <div className="hex-loader-pulse" />
        <div className="hex-loader-pulse p2" />
        <div className="hex-loader-pulse p3" />
        <div className="hex-loader-orbit-hex o1" />
        <div className="hex-loader-orbit-hex o2" />
        <div className="hex-loader-orbit-hex o3" />
        <img className="hex-loader-logo" src="/Logo.png" alt="Graphenex" />
      </div>
      {showBrand && <div className="hex-loader-brand grx-text-gradient">GRAPHENEX</div>}
      <div className="hex-loader-label">{label}</div>
      {sub && <div className="hex-loader-sub">{sub}</div>}
    </div>
  );

  if (typeof document === 'undefined') return overlay;
  return createPortal(overlay, document.body);
};

export default HexLoader;
